'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'planet-ringed';
var width = 576;
var height = 512;
var aliases = [129680];
var unicode = 'e020';
var svgPathData = 'M477.3 66.7c-3.4 1.8-7 3.7-10.7 5.8-17-16.6-35.8-30.3-55.7-41.2 67.3-42.5 120.2-59 140.5-38.7 37.4 37.4-50.2 185.6-195.7 331.1S62 556.8 24.6 519.4c-20.3-20.3-3.8-73.1 38.7-140.5 10.9 19.9 24.6 38.6 41.2 55.7-2.1 3.7-4 7.3-5.8 10.7 5.7-3 11.8-6.4 18.3-10.3 10.9-6.4 22.4-13.8 34.5-22-43.8-38.1-71.5-94.3-71.5-157 0-114.9 93.1-208 208-208 62.6 0 118.8 27.7 157 71.5 8.2-12 15.6-23.5 22-34.5 3.8-6.5 7.3-12.6 10.3-18.3zM389.6 357.6c39.5-39.5 75.3-79.6 105.7-118.1 .4 5.4 .6 10.9 .6 16.4 0 114.9-93.1 208-208 208-5.5 0-11-.2-16.4-.6 38.5-30.5 78.5-66.2 118.1-105.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlanetRinged = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;